import type { AdfoxImageCreative, AdfoxRenderData } from '../model/adfox';

function toAdfoxImageCreative(source?: Partial<AdfoxImageCreative>): AdfoxImageCreative | null {
  return source?.imageUrl ? { ...source, imageUrl: source.imageUrl } : null;
}

export function getAdfoxImageCreative(data?: AdfoxRenderData): AdfoxImageCreative | null {
  return toAdfoxImageCreative(data) ?? toAdfoxImageCreative(data?.attributes);
}
